// extracted by mini-css-extract-plugin
export default {"GenresComponent":"GenresComponent_GenresComponent__g2RLD","Active":"GenresComponent_Active__YHqeM"};